import {
  ACTIVATE_SELECT_ALL,
  ATTACHMENTS_AND_LINKS_FILTER_CHANGE,
  CLUSTER_UNDO_ASYNC,
  CLUSTER_UNDO_MODAL_CLOSE,
  DATA_REQUEST_ASYNC,
  DOWNLOAD_CSV_REQUEST,
  DOWNLOAD_EMAIL_ASYNC,
  END_USERS_FILTER_CHANGE,
  IPS_FILTER_CHANGE,
  IS_READ_FILTER_CHANGE,
  JUNK_MAIL_FILTER_CHANGE,
  MAILBOX_FILTER_CHANGE,
  NOT_FOUND_FILTER_CHANGE,
  PAGINATE_CHANGE,
  REPORT_ID_SET,
  REVERT_BACK_TO_ORIGIN_ASYNC,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SELECT_TOGGLE,
  SENDER_FILTER_CHANGE,
  SORT_PROPERTY_CHANGE,
  STOP_REMEDIATION_ASYNC,
  SUBJECT_FILTER_CHANGE,
  TOGGLE_RELEASE_FILTER,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export const downloadCsv = () => ({ type: DOWNLOAD_CSV_REQUEST.INITIATE })
export const downloadCsvSuccess = (data) => ({
  type: DOWNLOAD_CSV_REQUEST.SUCCESS,
  payload: { data },
})
export const downloadCsvError = (error) => ({
  type: DOWNLOAD_CSV_REQUEST.ERROR,
  error,
})

const setReportId = (reportId) => ({
  type: REPORT_ID_SET,
  payload: { reportId },
})

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const senderFilterChange = (arr) => ({
  type: SENDER_FILTER_CHANGE,
  payload: { arr },
})
const subjectFilterChange = (arr) => ({
  type: SUBJECT_FILTER_CHANGE,
  payload: { arr },
})
const mailboxFilterChange = (arr) => ({
  type: MAILBOX_FILTER_CHANGE,
  payload: { arr },
})
const ipsFilterChange = (selectedIpsArray) => ({
  type: IPS_FILTER_CHANGE,
  payload: { selectedIpsArray },
})
const junkMailFilterChange = (arr) => ({
  type: JUNK_MAIL_FILTER_CHANGE,
  payload: { arr },
})

const attachmentsAndLinksFilterChange = (val) => ({
  type: ATTACHMENTS_AND_LINKS_FILTER_CHANGE,
  payload: { val },
})
const notFoundFilterChange = (val) => ({
  type: NOT_FOUND_FILTER_CHANGE,
  payload: { val },
})
const isReadFilterChange = (val) => ({
  type: IS_READ_FILTER_CHANGE,
  payload: { val },
})

export const endUsersFilterChange = (val) => ({
  type: END_USERS_FILTER_CHANGE,
  payload: { val },
})

const toggleSelect = (id) => ({ type: SELECT_TOGGLE, payload: { id } })
const activateSelectAll = () => ({ type: ACTIVATE_SELECT_ALL })

const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})

const clusterUndo = (newState) => ({
  type: CLUSTER_UNDO_ASYNC.INITIATE,
  payload: { newState },
})
const clusterUndoCancel = () => ({ type: CLUSTER_UNDO_ASYNC.CANCEL })
export const clusterUndoSuccess = (data) => ({
  type: CLUSTER_UNDO_ASYNC.SUCCESS,
  payload: { data },
})
export const clusterUndoError = (error) => ({
  type: CLUSTER_UNDO_ASYNC.ERROR,
  error,
})

const revertBackToOrigin = (emailIds) => ({
  type: REVERT_BACK_TO_ORIGIN_ASYNC.INITIATE,
  payload: { emailIds },
})
export const revertBackToOriginSuccess = (data) => ({
  type: REVERT_BACK_TO_ORIGIN_ASYNC.SUCCESS,
  payload: { data },
})
export const revertBackToOriginError = (error) => ({
  type: REVERT_BACK_TO_ORIGIN_ASYNC.ERROR,
  error,
})

const clusterUndoModalClose = () => ({ type: CLUSTER_UNDO_MODAL_CLOSE })

const stopRemediation = (reportId) => ({
  type: STOP_REMEDIATION_ASYNC.INITIATE,
  payload: { reportId },
})
export const stopRemediationSuccess = (data) => ({
  type: STOP_REMEDIATION_ASYNC.SUCCESS,
  payload: { data },
})
export const stopRemediationError = (error) => ({
  type: STOP_REMEDIATION_ASYNC.ERROR,
  error,
})

export const downloadEmail = (mitigationId) => ({
  type: DOWNLOAD_EMAIL_ASYNC.INITIATE,
  payload: { mitigationId },
})
export const downloadEmailSuccess = (data) => ({
  type: DOWNLOAD_EMAIL_ASYNC.SUCCESS,
  payload: { data },
})
export const downloadEmailError = (error, id) => ({
  type: DOWNLOAD_EMAIL_ASYNC.ERROR,
  payload: { error, id },
})

export const toggleReleaseFilter = () => ({ type: TOGGLE_RELEASE_FILTER })

export default {
  // to props
  setReportId,
  fetchData,
  downloadCsv,
  sortPropertyChange,
  fetchDataCancel,
  searchChange,
  searchReset,
  paginateChange,
  senderFilterChange,
  subjectFilterChange,
  mailboxFilterChange,
  ipsFilterChange,
  junkMailFilterChange,
  notFoundFilterChange,
  attachmentsAndLinksFilterChange,
  isReadFilterChange,
  endUsersFilterChange,
  toggleSelect,
  activateSelectAll,
  clusterUndo,
  clusterUndoCancel,
  clusterUndoModalClose,
  stopRemediation,
  revertBackToOrigin,
  toggleReleaseFilter,
  downloadEmail,
}
